import { render, staticRenderFns } from "./CustomersTablePage.vue?vue&type=template&id=09aaf566"
import script from "./CustomersTablePage.vue?vue&type=script&lang=js"
export * from "./CustomersTablePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports